
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { mailRulesEl, mobileRulesEl, supplierCodeRulesEl } from "@common/src/utils/verify";
import AreaSelect from "@/components/scope/area-select.vue";
import t from "@common/src/i18n/t";
import CustomerFlagSelect from "@common/src/components/scope/flag-select/index.vue";
const supplier = namespace("supplier");
const base = namespace("base");

@Component({
  components: { AreaSelect, CustomerFlagSelect }
})
export default class SupplierEdit extends Vue {
  @supplier.Action createSupplier;
  @supplier.Action getSupplierDetail;
  @supplier.Action updateSupplier;
  @base.Action getDictionaryList;
  get breadData() {
    return [
      { name: t("setting.supplier-information"), path: "/setting/supplier" },
      {
        name: this.$route.name === "supplierAdd" ? t("setting.add-supplier") : t("setting.edit-supplier")
      }
    ];
  }
  showAreaSelect: boolean = false;
  supplierFormData = {
    supplierName: "",
    operatingGoods: [],
    businessScope: [],
    contactName: "",
    contactMobile: "",
    contactMail: "",
    stateName: "",
    cityName: "",
    districtName: "",
    area: [],
    address: "",
    settleMethod: "1",
    openBank: "",
    bankAccount: "",
    status: 1,
    supplierNumber: ""
  };
  roleList: any[] = [];
  areaOptions: any[] = [];
  areaValue: any = "";

  payOptions: any[] = [];
  supplierFormRules = {
    supplierName: [{ required: true, message: t("setting.enter-supplier-name"), trigger: "blur" }],
    supplierNumber: [
      { validator: (rule, value, callback) => supplierCodeRulesEl(value, callback, true), trigger: "blur" }
    ],
    status: [{ required: true, message: t("setting.select-whether-enable"), trigger: "blur" }],
    contactMail: [{ validator: this.validateMail, trigger: "blur" }],
    contactMobile: { validator: this.validateMobile, trigger: "blur" }
  };
  get isAdd() {
    return this.$route.name === "supplierAdd";
  }
  created() {
    this.init();
  }
  validateMail(rule, value, callback) {
    if (!value) {
      callback();
    } else {
      mailRulesEl(value, callback);
    }
  }
  validateMobile(rule, value, callback) {
    if (!value) {
      callback();
    } else {
      mobileRulesEl(value, callback);
    }
  }
  submitForm(formName) {
    (this.$refs[formName] as any).validate(valid => {
      if (valid) {
        if (this.isAdd) {
          this.addSupplier();
        } else {
          this.editSupplier();
        }
      } else {
        console.log("error submit!!");
        return false;
      }
    });
  }
  handleAreaChange() {
    this.supplierFormData.stateName = this.supplierFormData.area[0];
    this.supplierFormData.cityName = this.supplierFormData.area[1];
    this.supplierFormData.districtName = this.supplierFormData.area[2];
  }
  async init() {
    this.getDictionaryList("settle_method").then(data => {
      this.payOptions = data;
    });
    if (!this.isAdd) {
      const data = await this.getSupplierDetail({
        supplierCode: this.$route.params.id
      });
      this.supplierFormData = Object.assign(data.data, {
        area: [data.data?.stateName, data.data?.cityName, data.data?.districtName]
      });
    }
    this.showAreaSelect = true;
  }
  async addSupplier() {
    this.createSupplier(this.supplierFormData).then(() => {
      this.$message.success(t("base.success"));
      this.$router.push(`/setting/supplier`);
    });
  }
  async editSupplier() {
    (this.supplierFormData as any).userCode = this.$route.params.id;
    this.updateSupplier(this.supplierFormData).then(() => {
      this.$message.success(t("base.success"));
      this.$router.push(`/setting/supplier`);
    });
  }
}
